// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MoneyCollectTwoToneSvg from "@fishx/icons-svg/es/asn/MoneyCollectTwoTone";
import FishxIcon from '../components/FishxIcon';

var MoneyCollectTwoTone = function MoneyCollectTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MoneyCollectTwoToneSvg
  }));
};

MoneyCollectTwoTone.displayName = 'MoneyCollectTwoTone';
export default React.forwardRef(MoneyCollectTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MoneyCollectTwoTone.js
// module id = 3164
// module chunks = 0